var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

// require('moment');
// require('bootstrap');

// require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/button');
require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

require('bootstrap-select');
require('pc-bootstrap4-datetimepicker');
require('bootstrap-datepicker');

require('magnific-popup');

require('jquery.cookie');

 import Swiper, { Navigation } from 'swiper';

// require('jquery-sticky');
require('mmenu-js');

const feather = require('feather-icons');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    //feather icons
    feather.replace()

    var swiper = new Swiper(".mySwiper", {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {

            992: {
                slidesPerView: 5
          },
        },
      });


    $('#btn-menu').on('click',function () {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });
    $('#btn-mob-region').on('click',function () {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });

    $('.mm-slideout a').on('click',function () {
        $(this).toggleClass('open');
        $('.sidebar-offcanvas').toggleClass('active');
    });

    //mobile footer accordion icons
    $('.btn-collapse').on('click',function () {
        $(this).find('.toggle-icon').toggleClass('d-none');
    });

    $(window).on('load', function() {
        initFlipbook();
    });

    $('.datepicker').datetimepicker({
        format: 'YYYY-MM-DD'
    });



    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    if ($('.page-scroll').length) {
        // Page scroll
        $('.page-scroll').on('click', function (event) {
            event.preventDefault();
            var $anchor = $(this);

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - 104
            }, 500, 'easeInOutExpo');

        });
    }

    $('#btn-search, .btn-search-icon').on('click', function(e) {
        e.stopImmediatePropagation(); //

        $(".header-search").toggleClass('search-open');
        $('#btn-search').toggleClass('active');

        if($('.header-search').hasClass('search-open')){
            $('#header-search-input').trigger('focus');
        }

    });

    // Hide search on body click
	$('body').on('click', function(e) {
		if (!$('.search-open, #header-search-input').is(e.target) && !$('#btn-search, .btn-search-icon').is(e.target) )
        {
            $('#btn-search').removeClass('active');
		    $('.header-search').removeClass('search-open');
		}
	});

    // Facebook click events
    // phone
    $('a[href^="tel:"]').on('click', function(e) {
        window.fbq('track', 'Contact');
    });
    // email
    $('a[href^="mailto:"]').on('click', function(e) {
        window.fbq('track', 'Contact');
    });


});

window.recaptchaInit = function () {
    $(".g-recaptcha").each(function() {
        var el = $(this);
        grecaptcha.render($(el).attr("id"), {});
    });
    window.dispatchEvent(new CustomEvent('recaptcha-init'));
}

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}

function initFlipbook() {
    if ($('#flipbook').length > 0) {

        let pdf = $('#flipbook').data('src');
        let pdf_options = {
            webgl: true,
            height: "auto",
            backgroundColor: "#f3f1f0",
            enableDownload: false,
            scrollWheel: false,
            allControls: "pageNumber,zoomIn,zoomOut,fullScreen",
            moreControls: "",
            hideControls: "altPrev,altNext,share,thumbnail,sound,pageMode,startPage,endPage,more",
            soundEnable: false,
        };

        flipBook = $("#flipbook").flipBook(pdf, pdf_options);

        $('#brochure-tab').on('shown.bs.tab', function(e) {
            // fix hidden tab init issue
            flipBook.resize();
        });
    }
}

// document.addEventListener(
//     "DOMContentLoaded", () => {
//         new Mmenu("#mmenu", {
//             "extensions": [
//                 "theme-light", "position-front", "position-left"
//             ],
//         });
//     }
// );

function initSelectpickers(){
    $('.selectpicker').selectpicker({
        style: '',
        styleBase: 'dropdown-chevron btn-light',
        selectAllText: 'All',
        deselectAllText: 'None',
    });
}

window.initSelectpickers = initSelectpickers;